import axios from 'axios';
import i18n from '../i18n';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiToken = axios.create({
    baseURL: API_BASE_URL
});

apiToken.interceptors.request.use(config => {
    const token = sessionStorage.getItem('jwt');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers['x-locale'] = i18n.language;

    return config;
});

apiToken.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            window.open("/logout", "_self");
            //Lo que sea para deslogear
        }
        return Promise.reject(error);
    }
);

export default apiToken;